import React, { useEffect, useState } from "react"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link, useParams } from "react-router-dom"

const EditPlant = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [plant, setPlant] = useState(null)
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [taluks, setTaluks] = useState([])
  const [loadingDistricts, setLoadingDistricts] = useState(false)
  const [loadingTaluks, setLoadingTaluks] = useState(false)

  useEffect(() => {
    const loadData = async () => {
      try {
        const [plantResp, stResp] = await Promise.all([
          api.get("plant/" + id),
          api.get("states")
        ])
        const plantData = plantResp.data.data?.[0] || plantResp.data.data
        setPlant(plantData)
        setStates(Array.isArray(stResp.data.data) ? stResp.data.data : stResp.data.data?.data || [])

        // Load districts for plant's state
        if (plantData.state) {
          const dstResp = await api.get("districts/" + plantData.state)
          setDistricts(Array.isArray(dstResp.data.data) ? dstResp.data.data : dstResp.data.data?.data || [])
          // Load taluks for plant's district
          if (plantData.district) {
            const tlkResp = await api.get("taluks/" + plantData.district)
            setTaluks(Array.isArray(tlkResp.data.data) ? tlkResp.data.data : tlkResp.data.data?.data || [])
          }
        }
      } catch (e) { console.error(e) }
      setPageLoad(false)
    }
    loadData()
  }, [id])

  const stateChangeHandler = async e => {
    const stateId = e.target.value
    setDistricts([]); setTaluks([])
    if (!stateId) return
    setLoadingDistricts(true)
    try {
      const resp = await api.get("districts/" + stateId)
      setDistricts(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setLoadingDistricts(false)
  }

  const districtChangeHandler = async e => {
    const districtId = e.target.value
    setTaluks([])
    if (!districtId) return
    setLoadingTaluks(true)
    try {
      const resp = await api.get("taluks/" + districtId)
      setTaluks(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setLoadingTaluks(false)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const resp = await api.put("update-plant/" + id, values)
      if (resp.data.success) { setSubmitted(true); setTimeout(() => setSubmitted(false), 4000) }
    } catch (error) { console.error(error) }
    setLoading(false)
  }

  if (pageLoad) return <div className="dashBody"><div className="text-center py-5"><Spinner color="primary" style={{ width: "3rem", height: "3rem" }} /><p className="mt-3 text-muted">Loading Plant...</p></div></div>
  if (!plant) return <div className="dashBody"><p>Plant not found</p></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Edit Plant</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}>
            <Link to="/plants" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link>
          </Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal mt-4" onValidSubmit={handleValidSubmit}>

          {/* Plant Info */}
          <h6 style={{ color: "#6366f1", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px" }}>
            <i className="fas fa-industry"></i> Plant Information
          </h6>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField name="name" label="Plant Name *" value={plant.name} type="text" required />
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField name="number" label="Plant Number *" value={plant.number} type="text" required />
            </div></Col>
          </Row>

          {/* Address: State → District → Taluk → Village → Door → Pincode */}
          <h6 style={{ color: "#0ea5e9", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-map-marker-alt"></i> Address Details
          </h6>
          <Row>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="state" label="State *" required value={String(plant.state || "")} onChange={stateChangeHandler}>
                <option value="">Select State</option>
                {states.map((s, i) => <option key={i} value={String(s.id)}>{s.state}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="district" label={<>District * {loadingDistricts && <Spinner size="sm" color="primary" className="ms-1" />}</>} required value={String(plant.district || "")} onChange={districtChangeHandler}>
                <option value="">{loadingDistricts ? "Loading districts..." : districts.length ? "Select District" : "Select State first"}</option>
                {districts.map((d, i) => <option key={i} value={String(d.id)}>{d.district}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="taluk" label={<>Taluk * {loadingTaluks && <Spinner size="sm" color="primary" className="ms-1" />}</>} required value={plant.taluk || ""}>
                <option value="">{loadingTaluks ? "Loading taluks..." : taluks.length ? "Select Taluk" : "Select District first"}</option>
                {taluks.map((t, i) => <option key={i} value={t.taluk}>{t.taluk}</option>)}
              </AvField>
            </div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="village" label="Village *" value={plant.village} type="text" required /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="door" label="Door No *" value={plant.door} type="text" required /></div></Col>
            <Col md={4}><div className="mb-3">
              <AvField name="pincode" label="Pin Code *" value={plant.pincode} type="text" required
                validate={{
                  required: { value: true, errorMessage: "Pin code is required" },
                  pattern: { value: /^[1-9][0-9]{5}$/, errorMessage: "Enter valid 6-digit pin code" },
                  minLength: { value: 6, errorMessage: "Pin code must be 6 digits" },
                  maxLength: { value: 6, errorMessage: "Pin code must be 6 digits" }
                }} />
            </div></Col>
          </Row>

          {/* Management */}
          <h6 style={{ color: "#22c55e", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-user-tie"></i> Management
          </h6>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField name="plantManager" label="Plant Manager *" value={plant.plantManager} type="text" required />
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField name="productionManager" label="Production Manager *" value={plant.productionManager} type="text" required />
            </div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">
              {submitted && <UncontrolledAlert color="success"><strong>Plant Updated Successfully!</strong></UncontrolledAlert>}
            </div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner size="sm" /><span style={{ paddingLeft: "10px" }}>Updating...</span></> : <span><i className="fas fa-save"></i> Update Plant</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default EditPlant
